import { accordionPropsSchema } from '../component-catalog.js';
export const accordionDefinition = {
    type: 'Accordion',
    category: 'layout',
    propsSchema: accordionPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    expandsVertically: true,
    description: 'Collapsible sections that expand and contract. Props: sections (required, array of { id, label }), defaultOpen?, allowMultiple?.',
};
//# sourceMappingURL=Accordion.js.map